import { Link } from 'react-router';
import { SEO } from '@/components/seo/seo';
import { PressReleaseLayout } from '@/components/press/press-release-layout';
import { getPressRelease } from '@/data/press-releases';

/**
 * Renders a single press release by slug. Routes are generated from the
 * press-releases collection (see routes.tsx), so a missing slug only occurs in
 * defensive/manual navigation; we render a graceful, noindex'd fallback.
 */
export function PressReleasePage({ slug }: { slug: string }) {
  const release = getPressRelease(slug);

  if (!release) {
    return (
      <div className="relative">
        <SEO
          title="Press release not found | Fixtyer"
          description="This press release could not be found."
          noindex
        />
        <section className="py-24 bg-white">
          <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="font-display text-3xl font-bold text-brand-950 mb-4">
              Press release not found
            </h1>
            <p className="text-surface-700 mb-8">
              The press release you are looking for is not available.
            </p>
            <Link
              to="/press"
              className="inline-flex items-center justify-center px-6 py-3 bg-brand-600 text-white font-semibold rounded-xl hover:bg-brand-700 transition-colors"
            >
              View all press releases
            </Link>
          </div>
        </section>
      </div>
    );
  }

  return <PressReleaseLayout release={release} />;
}
